/**
 * GlassCard Component
 *
 * Canonical translucent-glass surface for the redesigned theme.
 * Use this for new content panels rather than the older `Card`
 * component (which is retained for back-compat during migration).
 *
 * Variants:
 *   - "strong"  (default): 94% parchment glass — body copy lives here.
 *   - "subtle": 82% glass — atmospheric panels (HomePage hero only).
 *   - "dark":   navy glass — header/footer style surfaces.
 *
 * Usage:
 *   <GlassCard>...</GlassCard>
 *   <GlassCard variant="subtle" as="section" padding="lg">...</GlassCard>
 */

import React from 'react';
import './GlassCard.css';

export const GLASS_VARIANTS = {
  STRONG: 'strong',
  SUBTLE: 'subtle',
  DARK: 'dark'
};

export const GLASS_PADDING = {
  NONE: 'none',
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
};

export function GlassCard({
  variant = GLASS_VARIANTS.STRONG,
  padding = GLASS_PADDING.MD,
  as: Component = 'div',
  hoverable = false,
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'glass-card',
    `glass-card--${variant}`,
    `glass-card--pad-${padding}`,
    hoverable && 'glass-card--hoverable',
    className
  ].filter(Boolean).join(' ');

  return (
    <Component className={cls} {...rest}>
      {children}
    </Component>
  );
}

export default GlassCard;
